import { useCallback, useEffect, useState } from 'react'

const KEYMAP = {
  ArrowUp:    { dr: -1, dc:  0, dir: 'up' },
  ArrowDown:  { dr:  1, dc:  0, dir: 'down' },
  ArrowLeft:  { dr:  0, dc: -1, dir: 'left' },
  ArrowRight: { dr:  0, dc:  1, dir: 'right' },
}

export default function useMovement(grid, startPos) {
  const [pos, setPos] = useState(startPos)
  const [direction, setDirection] = useState('down')
  const [moving, setMoving] = useState(false)

  const canWalk = useCallback((r, c) => {
    if (r < 0 || c < 0) return false
    if (r >= grid.length || c >= grid[0].length) return false
    const tile = grid[r][c]
    return tile === '.' || tile === 'S'
  }, [grid])

  // keydown: start moving in that direction
  const onKeyDown = useCallback((e) => {
    const m = KEYMAP[e.key]
    if (!m) return
    e.preventDefault()
    setDirection(m.dir)
    setMoving(true)
    setPos(p => {
      const nr = p.r + m.dr
      const nc = p.c + m.dc
      if (canWalk(nr, nc)) return { r: nr, c: nc }
      return p
    })
  }, [canWalk])

  // keyup: stop moving when key is released (only if it matches dir)
  const onKeyUp = useCallback((e) => {
    const m = KEYMAP[e.key]
    if (!m) return
    e.preventDefault()
    // If player is holding multiple keys you could track a set; for simplicity:
    setMoving(false)
  }, [])

  useEffect(() => {
    window.addEventListener('keydown', onKeyDown)
    window.addEventListener('keyup', onKeyUp)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
      window.removeEventListener('keyup', onKeyUp)
    }
  }, [onKeyDown, onKeyUp])

  return { pos, setPos, canWalk, direction, moving }
}
